<template>
    <div class="row">
        <div class="col-12 col-xl-12 stretch-card">
            <div class="row flex-grow-1">

                <!-- Encaissements -->
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-primary">
                            <h6 class="card-h6">
                                {{ i18n.t('tables.cashflow.encaissements') }}
                            </h6>
                            <h3 class="card-h3">
                                {{ totalEncaissements?.toFixed(2) ?? 0 }}
                                {{ i18n.t('symbole.currency.mad') }}
                            </h3>
                        </div>
                    </div>
                </div>

                <!-- Décaissements -->
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-secondary">
                            <h6 class="card-h6">
                                {{ i18n.t('tables.cashflow.decaissements') }}
                            </h6>
                            <h3 class="card-h3">
                                {{ totalDecaissements?.toFixed(2) ?? 0 }}
                                {{ i18n.t('symbole.currency.mad') }}
                            </h3>
                        </div>
                    </div>
                </div>

                <!-- Solde de caisse -->
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-tertiary">
                            <h6 class="card-h6">
                                {{ i18n.t('tables.cashflow.cashflow') }}
                            </h6>
                            <h3 class="card-h3">
                                {{ totalCashflow?.toFixed(2) ?? 0 }}
                                {{ i18n.t('symbole.currency.mad') }}
                            </h3>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import i18n from "@/i18n/index" 
import { CashReport } from "@/interfaces/cashReport";

export default defineComponent({
    name: 'cash-flow',
    props: {
        cashReport: {
            type: Object as () => CashReport ,
            required: true,
            default: () => [],
        } 
    },
    setup(props) {

 

        const totalEncaissements = computed(() => props.cashReport.encaissements)
        const totalDecaissements = computed(() => props.cashReport.decaissements)
        const totalCashflow = computed(() => props.cashReport.cashflow)

        return { 
            totalEncaissements,
            totalDecaissements,
            totalCashflow,
            i18n
        }
    },
});
</script>